import React from "react";
import { Form } from "@redriver/cinnamon";
import {
  socialMediaLinkRegexMapping,
  socialMediaLinkExampleMapping,
} from "constants/regexes";
import { RegexInput, RemovableArrayRow } from "components/forms";
import { socialMediaTypesLookup } from "modules/lookups";

const OtherSocialMediaItem = ({ item }) => (
  <div style={{ flexGrow: 1 }}>
    <Form.Array field={item.id} arrayKey="id" propagateUpdates="always">
      {({ fields }) => (
        <RemovableArrayRow columns={3}>
          <Form.Dropdown
            field="typeId"
            optionField="typeOption"
            lookup={socialMediaTypesLookup}
            placeholder="Select type"
            required
            requiredError="Social media type is required"
            fluid
          />
          <RegexInput
            field="value"
            fluid
            required
            regexPattern={
              fields.typeOption
                ? socialMediaLinkRegexMapping[fields.typeOption.type]
                : ".+"
            }
            regexFlags="i"
            placeholder="Enter your profile link"
            regexError={`Link must match the required format ${
              fields.typeOption
                ? socialMediaLinkExampleMapping[fields.typeOption.type]
                : ""
            }`}
            requiredError="Profile link is required"
          />
          <Form.Checkbox
            field="isPublic"
            label="Available to other participants"
          />
        </RemovableArrayRow>
      )}
    </Form.Array>
    <Form.ArrayAdder
      field={item.id}
      arrayKey="id"
      icon="plus"
      content="Add another social media link"
      primary
      compact
      populate={(arrayKey) => ({
        [arrayKey]: Date.now(),
        isPublic: true,
      })}
    />
  </div>
);

export default OtherSocialMediaItem;
